import { CommonCardContainer } from "../../components/DashboardCards/cardStyles";
import SubTaskTable from "../Jobs/CreateJob/SubTaskTable";
import {
  CommonGrid,
  CommonText,
  PageTitle,
} from "../../styledComponents/common";
import {
  ButtonIcon,
  ColoredButtonWithIcon,
} from "../../styledComponents/buttons";
import PlusWhite from "../../assets/img/icons/plus_white.svg";

const SubtaskSection = ({
  subTaskList,
  setSubTaskList,
  setIsSubTaskModalOpen,
  openEditSubTaskModal,
  onDeleteSubTask,
}) => {
  return (
    <CommonCardContainer style={{ marginTop: "20px" }} bgColor="#EDF8FE">
      <CommonGrid margin="0 0 10px 0" alignItem="start" columns="1fr 200px">
        <PageTitle>Subtasks</PageTitle>
        <ColoredButtonWithIcon onClick={() => setIsSubTaskModalOpen(true)}>
          <ButtonIcon src={PlusWhite} alt="" />
          Add Subtasks
        </ColoredButtonWithIcon>
      </CommonGrid>
      {/* table will be there */}
      {subTaskList && subTaskList.length > 0 ? (
        <SubTaskTable
          subTaskList={subTaskList}
          setSubTaskList={setSubTaskList}
          onEditSubTask={openEditSubTaskModal}
          onDeleteSubTask={onDeleteSubTask}
        />
      ) : (
        <CommonText>No subtasks added yet</CommonText>
      )}
    </CommonCardContainer>
  );
};

export default SubtaskSection;

